import type { RouteRecordRaw } from 'vue-router'
import { zaloRoutingMessages } from '@/features/zalo-routing/i18n/zalo-routing.messages'

export const zaloRoutingRouteMetadata = {
  path: 'resources/zalo-routing',
  name: 'resource-zalo-routing',
  permission: 'users.manage',
  moduleNav: 'resource',
  menuKey: 'resource-zalo-routing',
  pageTitleKey: 'zaloRouting.title',
  pageSubtitleKey: 'zaloRouting.subtitle',
  menuLabelKey: 'zaloRouting.menuLabel',
} as const

export const zaloRoutingRoute: RouteRecordRaw = {
  path: zaloRoutingRouteMetadata.path,
  name: zaloRoutingRouteMetadata.name,
  component: () => import('@/features/zalo-routing/pages/ZaloRoutingPage.vue'),
  props: { moduleNav: zaloRoutingRouteMetadata.moduleNav },
  meta: {
    permission: zaloRoutingRouteMetadata.permission,
    moduleNav: zaloRoutingRouteMetadata.moduleNav,
    pageTitleKey: zaloRoutingRouteMetadata.pageTitleKey,
  },
}

export const zaloRoutingLegacyRoute: RouteRecordRaw = {
  path: 'system/zalo-routing',
  redirect: { name: zaloRoutingRouteMetadata.name },
}

export const zaloRoutingMenuMetadata = {
  key: zaloRoutingRouteMetadata.menuKey,
  routeName: zaloRoutingRouteMetadata.name,
  path: `/${zaloRoutingRouteMetadata.path}`,
  permission: zaloRoutingRouteMetadata.permission,
  moduleNav: zaloRoutingRouteMetadata.moduleNav,
  labelKey: zaloRoutingRouteMetadata.menuLabelKey,
  labels: {
    vi: zaloRoutingMessages.vi.zaloRouting.menuLabel,
    en: zaloRoutingMessages.en.zaloRouting.menuLabel,
    zh: zaloRoutingMessages.zh.zaloRouting.menuLabel,
  },
} as const
